
import React from "react";
import { Schemes } from "../../../../../../utils";
import { i18nManager } from "../../../../../../i18n";
import { Elements } from "../../../../../shared/Elements";
import { Button, Checkbox, Classname, Form } from "@rivtn/noseur";
import { BaseService, IMember, ITournamentEdition, ITournamentEditionWebsite, SanitizedResponse, TournamentService } from "../../../../../../services";
import { Siren } from "../../../../../shared/ConfirmDialog";

export interface ParticipantsProps {
    profile: IMember;
    tournamentEdition: ITournamentEdition;
    tournamentEditionWebsite: ITournamentEditionWebsite;
}

function Participants(props: ParticipantsProps) {

    const { tournamentEdition } = props;
    const tournamentService = TournamentService.getInstance();
    const labels = i18nManager.Labels.host.manage_tournament.settings.participants;
    const [tournamentEditionWebsite, setTournamentEditionWebsite] = React.useState<ITournamentEditionWebsite>(props.tournamentEditionWebsite);

    return (<Form scheme={Schemes.OMNEHOST} className={Classname.build("profile-settings", "team-settings")}>
        <Checkbox label={labels.enable_ad} defaultChecked={tournamentEditionWebsite?.participants_settings?.enable_rivtn_ad} onChange={(e: any) => {
            setTournamentEditionWebsite({ ...tournamentEditionWebsite, participants_settings: { ...tournamentEditionWebsite.participants_settings, enable_rivtn_ad: e.checked } });
        }} />
        <hr />
        <Checkbox label={labels.show_current} defaultChecked={tournamentEditionWebsite?.participants_settings?.show_current_participants} onChange={(e: any) => {
            setTournamentEditionWebsite({ ...tournamentEditionWebsite, participants_settings: { ...tournamentEditionWebsite.participants_settings, show_current_participants: e.checked } })
        }} />
        <Checkbox label={labels.show_previous} defaultChecked={tournamentEditionWebsite?.participants_settings?.show_previous_participants} onChange={(e: any) => {
            setTournamentEditionWebsite({ ...tournamentEditionWebsite, participants_settings: { ...tournamentEditionWebsite.participants_settings, show_previous_participants: e.checked } })
        }} />
        <Button scheme={Schemes.OMNEHOST} text={i18nManager.Labels.common.save_changes} loadingProps={Elements.BUTTON_LOADING_PROPS}
            style={{ marginTop: 20 }} onClick={(e) => {
                e.manageRef?.setLoadingState(true);
                updateProfileWebsite(() => e.manageRef?.setLoadingState(false));
            }} />
    </Form>);

    function updateProfileWebsite(onDone?: () => void) {
        tournamentService.updateTournamentEditionWebsite(tournamentEdition.external_id, tournamentEditionWebsite!).then(({ sanitized }: SanitizedResponse<ITournamentEditionWebsite>) => {
            setTournamentEditionWebsite(sanitized);
            Siren.alert(labels.success);
        }).catch(BaseService.reportError).finally(onDone);
    }

}

export default Participants;
